/** User may open / complete this material without a subscription (or staff / subscribed). */
export function hasFullLibraryAccess(
  hasSubscription: boolean | null,
  isStaff: boolean
): boolean {
  return Boolean(isStaff || hasSubscription);
}

export function canUseSegment(
  hasSubscription: boolean | null,
  isStaff: boolean,
  segmentIsFreePublic?: boolean
): boolean {
  return hasFullLibraryAccess(hasSubscription, isStaff) || Boolean(segmentIsFreePublic);
}

export function canUsePodcast(
  hasSubscription: boolean | null,
  isStaff: boolean,
  podcastIsFreePublic?: boolean
): boolean {
  return hasFullLibraryAccess(hasSubscription, isStaff) || Boolean(podcastIsFreePublic);
}

/** `dialogueIsFreePublic` = Dialogue Categories topic (`DialogueTopic.is_free_public`), not the parent category. */
export function canUseCategoryDialogue(
  hasSubscription: boolean | null,
  isStaff: boolean,
  dialogueIsFreePublic?: boolean
): boolean {
  return hasFullLibraryAccess(hasSubscription, isStaff) || Boolean(dialogueIsFreePublic);
}
